import React, { useState } from "react";
import {
  Navbar,
  Container,
  Form,
  Button,
  Dropdown,
  Badge
} from "react-bootstrap";
import {
  Search,
  PersonCircle,
  Cart3,
  Heart
} from "react-bootstrap-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./header.scss"; // create this scss file
import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { WishlistContext } from "../context/WishlistContext";
import { ShopContext } from "../context/ShopContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { isAuthenticated, logout, getUser } from "../utils/auth";
import { image_base_url } from "../admin/api/api";

function Header() {
  const [showSearch, setShowSearch] = useState(false);

  const { cartItems } = useContext(CartContext);
  const { wishlistItems } = useContext(WishlistContext);
  const { shop } = useContext(ShopContext);
  const navigate = useNavigate();

  const loggedIn = isAuthenticated();
  const user = getUser();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const itemCount = cartItems.reduce(
  (acc, item) => acc + item.quantity,
  0
  );

  // Temporary static counts (later connect to Context API)
  const wishlistCount = wishlistItems.length;


  return (
    <>
      <Navbar bg="light" className="shadow-sm py-2">
        <Container className="d-flex align-items-center justify-content-between">

          {/* Logo */}
          <Navbar.Brand href="/" className="fw-bold" style={{paddingTop : "0px", paddingBottom : "0px"}}>
            <img
              src={
    shop?.logoUrl
      ? `${image_base_url}${shop.logoUrl}`
      : "/images/swara-logo-smbg.png"
  }
  width="135"
  height="45"
  className="me-2"
  alt={shop?.shopName || "Store Logo"}
            />
            
          </Navbar.Brand>

          {/* Desktop Search */}
          <Form className="d-none d-lg-flex w-50 mx-4">
            <Form.Control
              type="search"
              placeholder="Search products..."
              className="me-0"
              style={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
              }}
            />
            <Button
              variant="warning"
              style={{
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
              }}
            >
              <Search />
            </Button>
          </Form>

          {/* Right Side Icons */}
          <div className="d-flex align-items-center text-center header-icons">

            {/* Mobile Search Icon */}
            <div className="d-lg-none icon-item">
              <Search
                size={20}
                onClick={() => setShowSearch(!showSearch)}
              />
              <div>Search</div>
            </div>

            {/* Profile Dropdown */}
            <Dropdown align="end">
              <Dropdown.Toggle
                as="div"
                className="icon-item profile-toggle"
              >
                <PersonCircle size={20} />
                <div className="profile-name">{loggedIn ? user?.name : "Profile"}</div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {/* NOT LOGGED IN */}
        {!loggedIn && (
          <>
            <Dropdown.Item as={Link} to="/login">
             <span style={{color:"Red"}}>Login</span>
            </Dropdown.Item>

            <Dropdown.Item as={Link} to="/register">
              <span style={{color:"Red"}}>New User</span>
            </Dropdown.Item>
          </>
        )}

        {/* LOGGED IN */}
        {loggedIn && (
          <>
            <Dropdown.Item disabled>
              <span>Hi, <strong style={{color:"blue"}}> {user?.name || user?.email}</strong></span> 
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item onClick={handleLogout}>
              <span style={{color:"Red"}}>Logout</span>
            </Dropdown.Item>
          </>
        )}



                <Dropdown.Item href="/my-orders">My Orders</Dropdown.Item>
                
                <Dropdown.Divider />
                <Dropdown.Item href="/profile">Profile</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Wishlist */}
            <div className="icon-item position-relative"
  onClick={() => navigate("/wishlist")}
  style={{cursor:"pointer"}}
>
  <Heart size={20} />

  {wishlistItems.length > 0 && (
    <Badge
      bg="danger"
      pill
      style={{
        position:"absolute",
        top:"-5px",
        right:"-6px"
      }}
    >
      {wishlistItems.length}
    </Badge>
  )}

  <div>Wishlist</div>
</div>

            {/* Cart */}
            <div className="icon-item position-relative"
            onClick={() => navigate("/cart")}
            style={{ cursor: "pointer", position: "relative" }} >
              <Cart3 size={20} />
              {itemCount > 0 && (
    <Badge
      bg="danger"
      pill
      style={{
        position: "absolute",
        top: "-5px",
        right: "-10px"
      }}
    >
      {itemCount}
    </Badge>
  )}
              <div>Cart</div>
            </div>

          </div>
        </Container>
      </Navbar>

      {/* Mobile Search Box */}
      {showSearch && (
        <div className="d-lg-none p-2 border-bottom bg-light">
          <Form className="d-flex">
            <Form.Control
              type="search"
              placeholder="Search products..."
              className="me-0"
              style={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
              }}
            />
            <Button
              variant="warning"
              style={{
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
              }}
            >
              <Search />
            </Button>
          </Form>
        </div>
      )}
    </>
  );
}

export default Header;